import React, { useMemo } from 'react';
import JsonEditor from '../../JsonEditor';
import { getAlarmPanelAdminSchema } from '../../panels/AlarmPanel/alarmPanelSchema';

const AlarmSettings = ({ settings, onSave, onFullSettings, onClose }) => {
  const schema = useMemo(() => getAlarmPanelAdminSchema(), []);
  return (
    <div className="column-content">
      <JsonEditor
        title=""
        schema={schema}
        formData={settings}
        onFormSubmit={onSave}
        onSecondaryAction={onFullSettings}
        cancelCallback={onClose}
        saveButtonText={'Save'}
        initialEditMode
        showEditButton={false}
      />
    </div>
  );
};

export default AlarmSettings;
